/* Which dashboard banners a given account should see.
 *
 * Pure, and kept out of the page so the rule can be read and tested without
 * standing up the whole dashboard.
 */

/* The companies this account is linked to — owns, manages, or has had a claim approved on. */
export const linkedCompanies = (userInfo) =>
  (userInfo?.individual?.[0]?.individual || []).filter((c) => c?.companyID?.companyID);

export const hasLinkedCompany = (userInfo) => linkedCompanies(userInfo).length > 0;

/* THE VERIFICATION BANNER.
 *
 * "Your business isn't Verified yet — click here to upgrade and unlock the
 * Verified badge."
 *
 * TIP-464's transcribed rule was the subscription half alone: show it to
 * anyone without an active `verified` subscription. That is every brand-new
 * account, including one with no business on TREVEX at all — so a user who
 * owns nothing was told their business was unverified and sent to billing to
 * fix something they cannot fix. There is no business to verify.
 *
 * So both halves are required now: an eligible company AND no active verified
 * subscription. The subscription half is unchanged; this only adds the company
 * one.
 */
export const showVerificationBanner = ({ userInfo, hasVerifiedSubscription }) =>
  hasLinkedCompany(userInfo) && !hasVerifiedSubscription;

export default showVerificationBanner;
